import http from './http'

export function fetchRecentPredictions(params = {}) {
  return http.get('/api/prediction/recent', { params })
}
